import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation} from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import About from './components/About';
import Home from './components/Home';
import Lims from './components/Lims';
import Eln from './components/Eln';
import Adbs from './components/Adbs';
import Careers from './components/Careers';
import ContactUs from './components/ContactUs';
import Footer from './components/Footer';
import Dms from './components/Dms';
import Qms from './components/Qms';
import Lms from './components/Lms';
import Elog from './components/Elog';
import Ipqc from './components/Ipqc';
import Vms from './components/Vms';
import Demo from './components/Demo';
import Downloads from './components/Downloads';
import SmallScreensNavbar from './components/smallscreennav';
import CookiePolicy  from './components/CookiePolicy';
import SaasSubscribeForm from './components/SaasSubscribeForm';
import LIMS_ELN from './components/Lims_eln';
import SaaS from './components/Saas';
import PharmaIndustry from './components/PharmaIndustry';
import BioTechIndustry from './components/BioTechIndustry';
import CroCdmo from './components/CroCdmo';
import FoodIndustry from './components/FoodIndustry';
import Academia from './components/Academia';
import StartUp from './components/StartUp';
import WhitePapersGrid from './components/WhitePapersGrid';
import Webinars from './components/Webinars';
import BlogsGrid from './components/BlogsGrid';
import BlogView from './components/BlogsView';
import BlogLayout from './components/BlogLayout';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFlaskVial, faMicroscope, faUsersCog, faVial, faUser, faFlask, faClock, } from '@fortawesome/free-solid-svg-icons';
import TLims from './components/TLims';
import NotFound from './components/NotFound';

library.add( faFlaskVial, faMicroscope, faUsersCog, faVial, faUser, faFlask, faClock, );

function App() {
  const [currentPage, setCurrentPage] = useState('home'); // Default to 'home'
  const [homeKey, setHomeKey] = useState(0);

  const handleNavClick = (pageName) => {
    setCurrentPage(pageName);
  };


  const HideUrl = () => {
    const location = useLocation();

    useEffect(() => {
      window.history.replaceState(null, "", "");
    }, [location]);
    return null;
  };

  function ScrolltoTop () {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: 'instant' 
      });
    }, [pathname]);

    return null;
  }

  return (
    <Router>
      <ScrolltoTop />
      <div className="App">
        <Header setHomeKey={setHomeKey} />
        <Routes>
          <Route path="/" element={
            <>
              <Home key={homeKey}/>
            </>
          } />
          <Route path="/lims" element={<Lims />} />
          <Route path="/eln" element={<Eln />} />
          <Route path="/adbs" element={<Adbs />} />
          <Route path="/qms" element={<Qms />} />
          <Route path="/dms" element={<Dms />} />
          <Route path="/lms" element={<Lms />} />
          <Route path="/elog" element={<Elog />} />
          <Route path="/e-logbook" element={<Elog />} />
          <Route path="/ipqc" element={<Ipqc />} />
          <Route path="/vms" element={<Vms />} />
          <Route path="/lims-eln" element={<LIMS_ELN />} />
          <Route path="/saas" element={<SaaS />} />
          <Route path="/saas-form" element={<SaasSubscribeForm />} />
          <Route path="/tlims" element={<TLims />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/pharma" element={<PharmaIndustry />} />
          <Route path="/biotech" element={<BioTechIndustry />} />
          <Route path="/cro-cdmo" element={<CroCdmo />} />
          <Route path="/foodindustry" element={<FoodIndustry />} />
          <Route path="/academia" element={<Academia />} />
          <Route path="/startup" element={<StartUp />} />
          <Route path="/whitepapers" element={<WhitePapersGrid />} />
          <Route path="/webinars" element={<Webinars />} />
          <Route path="/about" element={<About />} />
          <Route element={<BlogLayout />}>
            <Route path="/blogs" element={<BlogsGrid />} />
            <Route path="/blog/:id" element={<BlogView />} />
          </Route>
          <Route path='*' element={<NotFound />} />
        </Routes>
        <HideUrl />
        <Footer setHomeKey={setHomeKey} />
        <div className='d-none'>
          <SmallScreensNavbar />
        </div>
        <div className='d-none'>
          <ContactUs />
        </div>
        <CookiePolicy />
      </div>
    </Router>
  );
}

export default App;
